export default "__VITE_ASSET__3kBhuPc5__"